import * as React from 'react'
import { SVGProps } from 'react'

const SvgShibaInuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id='ShibaInuIcon_svg__Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x={0}
    y={0}
    viewBox='0 0 641.7 649'
    style={{
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      enableBackground: 'new 0 0 641.7 649',
    }}
    xmlSpace='preserve'
    {...props}>
    <style>
      {
        '.ShibaInuIcon_svg__st0{fill:#f00500}.ShibaInuIcon_svg__st1{fill:#fff}.ShibaInuIcon_svg__st2{fill:none}.ShibaInuIcon_svg__st4{fill:#ff9300}.ShibaInuIcon_svg__st5{fill:#ff8300}'
      }
    </style>
    <g id='ShibaInuIcon_svg__Group_938' transform='translate(-953.348 -232.003)'>
      <g id='ShibaInuIcon_svg__Group_931'>
        <path
          id='ShibaInuIcon_svg__Path_8573'
          className='ShibaInuIcon_svg__st0'
          d='M1423.2 289.1c-16.7 16.7-32 34.8-45.6 54.1l-4.3-1.4c-24.8-8.1-50.5-13.1-76.4-14.8-7.8-.6-36.9-.6-46.4 0-28.7 1.9-50.7 6.2-75.7 14.9-1 .4-1.9.7-2.8 1-14.1-19.2-29.8-37.2-47.1-53.7 83-42.5 180.1-47.6 267-14.1 9.3 3.5 18.4 7.6 27.3 12l4 2z'
        />
        <path
          id='ShibaInuIcon_svg__Path_8574'
          className='ShibaInuIcon_svg__st0'
          d='M1578 668.4c-12.6 35.9-31.5 69.2-56 98.2-13.3 15.6-28 29.9-43.8 42.9-37 29.8-80.2 51.1-126.3 62.3-51 12.3-104.2 12.3-155.2 0-46.2-11.2-89.3-32.5-126.3-62.3-15.8-13-30.5-27.3-43.8-42.9-70.5-83.3-91.9-197.7-56-300.8 6.8-19.1 15.3-37.5 25.5-55 4.7-8 10.5-17 13.3-20.7 9.6 41.3 21.4 77.6 25.8 90.7-.3.7-.7 1.5-1.1 2.2-23.3 47.2-35.9 92.7-38.9 141.1 0 .6-.1 1.3-.1 1.9-.8 14.5-.4 21.4 2 30.5 7.5 28.5 30.6 59.9 66.8 90.7 59.3 50.4 139.7 86.8 200.6 91 63.5 4.3 157.2-32.8 219.6-87 9.8-8.7 19-17.9 27.6-27.7 6.2-7.2 15.4-19.6 14.7-19.6-.2 0 0-.2.4-.4.3-.2.6-.5.4-.7-.1-.1.1-.4.4-.5.3-.1.5-.3.4-.5s0-.4.4-.5c.3-.1.4-.4.3-.6-.1-.2 0-.4.2-.4s.4-.3.4-.5.2-.5.4-.5.4-.2.4-.4c.3-.8.8-1.6 1.3-2.3 1.5-2.3 7.5-13 8.3-14.8 5.7-12.9 9.3-24.4 11-35.9.8-5.5 1.3-15.6.9-18-.1-.4-.1-1.1-.2-2.2-.2-2-.3-5-.5-8-.2-4.5-.6-10.8-.9-13.9-4.3-45.4-15.9-82.5-37.9-121.8-.9-1.5-1.7-3-2.2-4.2-.2-.3-.3-.6-.4-.8 3.1-9.3 15.8-48.2 25.9-92.7l.2.2 1.5 2c2.6 3.5 9.5 13.9 12.6 18.9 14.1 23 25.1 47.7 32.9 73.5 18.1 62.1 16.6 128.3-4.6 189.5z'
        />
        <path
          id='ShibaInuIcon_svg__Path_8575'
          d='M1448.2 548.9c-.3 1.6-5 6.4-9.7 9.9-13.8 10.1-38.5 19.5-63.6 24-14.3 2.6-28.6 3-32.9.9-2.8-1.4-3.2-2.5-2.2-6.1 2.1-7.5 8.9-15.7 19.5-23.4 5.4-3.9 27.3-17.2 37.5-22.8 16.8-9.2 30.4-14.7 39.6-16 2.9-.4 6.4-.5 7.5 0 1.8.7 3.8 6 4.6 12.4.4 3.4.2 18.4-.3 21.1z'
        />
        <path
          id='ShibaInuIcon_svg__Path_8576'
          d='M1212.6 582c-.6 1.2-3.6 2.5-7 3s-13.8.2-19.7-.5c-21.2-2.8-43.7-9.3-60.1-17.3-9.2-4.5-15.8-9-20.7-13.9l-2.8-2.9-.3-3.8c-.5-6.6-.4-17 .4-20.7.5-3.1 1.6-6.1 3.1-8.8.8-1 .8-1 4.4-1 4.4 0 8.1.7 14.1 2.6 12.3 3.8 30.6 13 52.9 26.4 18.4 11 25.3 16.4 30.6 23.8 3.6 4.6 6 11.1 5.1 13.1z'
        />
        <path
          id='ShibaInuIcon_svg__Path_8577'
          d='M1354.2 721.2c0 .3-1.2 5.1-2.7 10.8-1.5 5.7-2.7 10.3-2.7 10.5-1.1.1-2.1.2-3.2.1h-3.2L1338 753c-2.4 5.7-4.6 11-4.9 11.8l-.6 1.4-2.1-3.4-2.1-3.4v-27.7l-.8.2c-1.7.4-13.8 2-19.1 2.5-21.9 2.2-43.9 1.7-65.7-1.4-3.5-.5-6.5-.9-6.6-.8-.1.1 0 6.5.2 14.4l.3 14.2-1.7 2.6c-.9 1.4-1.8 2.6-1.8 2.7-.3.3-1.3-1.3-3.6-5.9-2.5-4.8-4.3-9.9-5.6-15.2l-.7-2.9-3.1.2-3.1.3-.8-3.7c-.4-2-.9-5.1-1.1-6.8l-.3-3.2-2.6-2.3c-1.5-1.3-3-2.6-3.3-2.8-.5-.4-.7-1.1-.7-1.7v-1.2l12.5.1 12.5.1.4 1.3.4 1.3 4.3.2c2.4.1 10 .3 16.8.5l12.5.3 3.2-5 3.3-5h4.2l-.1-10.4-.1-10.4-5.5-2.4c-17.7-7.8-28.1-16.7-32-27.5-.8-2.2-.8-3-1-13-.1-9.9-.1-10.8.6-13 1.4-5 5.3-8.9 10.3-10.2 1.7-.5 6.2-.5 29.8-.5l27.8.1 3.1 1.5c3.7 1.8 5.4 3.1 7.5 5.9 2.4 3.2 3.1 5.7 3.1 11.8 0 8.7-.6 16.2-1.5 19.2-1.3 4.1-3.3 8-5.8 11.5-5 6.4-14.1 12.8-22.4 15.7l-2.4.9.1 10.5.1 10.5 2.2.2 2.2.2 3 4.5 2.9 4.5h13.4c7.4 0 13.9.1 14.5.2 1 .2 1.2.1 2.2-1.6l1.2-1.8h11.5c8.6-.4 11.2-.2 11.2.1z'
        />
        <path
          id='ShibaInuIcon_svg__Path_8578'
          d='M1301.4 749.9c-1.9 1.1-3.2 1.6-3.5 1.4-.3-.1-1.7-1.3-3.2-2.4l-2.7-2.2-2.8 3c-6.1 6.6-6.3 6.9-8.1 7-2.8.3-3.4-.2-6.8-5.3-1.8-2.6-3.2-4.8-3.2-4.8s-1.3-.2-2.8-.3l-2.8-.3-1.3 2.7-1.3 2.7-2.3-.7c-1.8-.6-3.6-1.3-5.3-2.1l-3-1.5v-5.7l26.6.1 26.6.1.1 2.7c.1 3.2.2 3.1-4.2 5.6z'
        />
      </g>
      <path
        id='ShibaInuIcon_svg__Path_8579'
        className='ShibaInuIcon_svg__st1'
        d='M1551.4 627.9c-.1-.4-.1-1.1-.2-2.2-24-2.6-92.5-4.2-156.1 48.3 0 0-20.5-94-116.5-94S1147 674 1147 674c-53.8-57.9-125.8-53.7-151.8-49.9 0 .6-.1 1.3-.1 1.9-.8 14.5-.4 21.4 2 30.5 7.5 28.5 30.6 59.9 66.8 90.7 59.3 50.4 139.7 86.8 200.6 91 63.5 4.3 157.2-32.8 219.6-87 9.8-8.7 19-17.9 27.6-27.7 6.2-7.2 15.4-19.6 14.7-19.6-.2 0 0-.2.4-.4.3-.2.6-.5.4-.7-.1-.1.1-.4.4-.5.3-.1.5-.3.4-.5s0-.4.4-.5c.3-.1.4-.4.3-.6-.1-.2 0-.4.2-.4s.4-.3.4-.5.2-.5.4-.5.4-.2.4-.4c.3-.8.8-1.6 1.3-2.3 1.5-2.3 7.5-13 8.3-14.8 5.7-12.9 9.3-24.4 11-35.9.6-5.5 1.1-15.6.7-18zm-250 122c-1.9 1.1-3.2 1.6-3.5 1.4-.3-.1-1.7-1.3-3.2-2.4l-2.7-2.2-2.8 3c-6.1 6.6-6.3 6.9-8.1 7-2.8.3-3.4-.2-6.8-5.3-1.8-2.6-3.2-4.8-3.2-4.8s-1.3-.2-2.8-.3l-2.8-.3-1.3 2.7-1.3 2.7-2.3-.7c-1.8-.6-3.6-1.3-5.3-2.1l-3-1.5v-5.7l26.6.1 26.6.1.1 2.7c.1 3.2.2 3.1-4.2 5.6zm50-18c-1.5 5.7-2.7 10.3-2.7 10.5-1.1.1-2.1.2-3.2.1h-3.2L1338 753c-2.4 5.7-4.6 11-4.9 11.8l-.6 1.4-2.1-3.4-2.1-3.4v-27.7l-.8.2c-1.7.4-13.8 2-19.1 2.5-21.9 2.2-43.9 1.7-65.7-1.4-3.5-.5-6.5-.9-6.6-.8-.1.1 0 6.5.2 14.4l.3 14.2-1.7 2.6c-.9 1.4-1.8 2.6-1.8 2.7-.3.3-1.3-1.3-3.6-5.9-2.5-4.8-4.3-9.9-5.6-15.2l-.7-2.9-3.1.2-3.1.3-.8-3.7c-.4-2-.9-5.1-1.1-6.8l-.3-3.2-2.6-2.3c-1.5-1.3-3-2.6-3.3-2.8-.5-.4-.7-1.1-.7-1.7v-1.2l12.5.1 12.5.1.4 1.3.4 1.3 4.3.2c2.4.1 10 .3 16.8.5l12.5.3 3.2-5 3.3-5h4.2l-.1-10.4-.1-10.4-5.5-2.4c-17.7-7.8-28.1-16.7-32-27.5-.8-2.2-.8-3-1-13-.1-9.9-.1-10.8.6-13 1.4-5 5.3-8.9 10.3-10.2 1.7-.5 6.2-.5 29.8-.5l27.8.1 3.1 1.5c3.7 1.8 5.4 3.1 7.5 5.9 2.4 3.2 3.1 5.7 3.1 11.8 0 8.7-.6 16.2-1.5 19.2-1.3 4.1-3.3 8-5.8 11.5-5 6.4-14.1 12.8-22.4 15.7l-2.4.9.1 10.5.1 10.5 2.2.2 2.2.2 3 4.5 2.9 4.5h13.4c7.4 0 13.9.1 14.5.2 1 .2 1.2.1 2.2-1.6l1.2-1.8h11.5c8.9 0 11.5.1 11.5.4-.3-.1-1.6 4.8-3.1 10.4z'
      />
      <path id='ShibaInuIcon_svg__Path_8580' className='ShibaInuIcon_svg__st2' d='M995 624.1c-6.3.9-10 1.9-10 1.9' />
      <path id='ShibaInuIcon_svg__Path_8581' className='ShibaInuIcon_svg__st2' d='M1560.1 627s-3.2-.7-8.9-1.3' />
      <path
        id='ShibaInuIcon_svg__Path_8582'
        d='M1550.6 617.7c-.2-4.5-.6-10.8-.9-13.9-4.3-45.4-15.9-82.5-37.9-121.8-.9-1.5-1.7-3-2.2-4.2-.2-.3-.3-.6-.4-.8 3.1-9.3 15.8-48.2 25.9-92.7 13.7-60.4 22.4-131-4.2-152.2 0 0-46-3.4-107.6 57-16.7 16.7-32 34.8-45.6 54.1l-4.3-1.4c-24.8-8.1-50.5-13.1-76.4-14.8-7.8-.6-36.9-.6-46.4 0-28.7 1.9-50.7 6.2-75.7 14.9-1 .4-1.9.7-2.8 1-14.1-19.2-29.8-37.2-47.1-53.7-64.1-60.7-111.8-57.2-111.8-57.2-28.2 21.9-18.6 95.7-4 158.1 9.6 41.3 21.4 77.6 25.8 90.7-.3.7-.7 1.5-1.1 2.2-23.3 47.2-35.9 92.7-38.9 141.1 26.1-3.8 98-8.1 151.9 49.9 0 0 35.6-94 131.6-94s116.5 94 116.5 94c63.6-52.5 132.1-50.8 156.1-48.3-.1-2-.3-5-.5-8zm-496.7-174.6s-37.4-93.5-27.8-146.9c1.6-9 4.6-16.9 9.3-22.9 0 0 42.4 4.2 110.8 80.2 0 0-13 6.3-30.4 19.7 0 0-.1.1-.2.1-18.9 14.5-43.1 37.5-61.7 69.8zM1212.6 582c-.6 1.2-3.6 2.5-7 3s-13.8.2-19.7-.5c-21.2-2.8-43.7-9.3-60.1-17.3-9.2-4.5-15.8-9-20.7-13.9l-2.8-2.9-.3-3.8c-.5-6.6-.4-17 .4-20.7.5-3.1 1.6-6.1 3.1-8.8.8-1 .8-1 4.4-1 4.4 0 8.1.7 14.1 2.6 12.3 3.8 30.6 13 52.9 26.4 18.4 11 25.3 16.4 30.6 23.8 3.6 4.6 6 11.1 5.1 13.1zm235.6-33.1c-.3 1.6-5 6.4-9.7 9.9-13.8 10.1-38.5 19.5-63.6 24-14.3 2.6-28.6 3-32.9.9-2.8-1.4-3.2-2.5-2.2-6.1 2.1-7.5 8.9-15.7 19.5-23.4 5.4-3.9 27.3-17.2 37.5-22.8 16.8-9.2 30.4-14.7 39.6-16 2.9-.4 6.4-.5 7.5 0 1.8.7 3.8 6 4.6 12.4.4 3.4.2 18.4-.3 21.1zm-16.6-175.7-.2-.1c-16.8-13.4-29.4-19.7-29.4-19.7 66.1-76 107-80.2 107-80.2 4.5 6.1 7.4 13.9 9 22.9 9.3 53.4-26.8 147-26.8 147-15.1-26.9-35.4-50.7-59.6-69.9z'
        style={{
          fill: '#ffa409',
        }}
      />
      <path id='ShibaInuIcon_svg__Path_8583' className='ShibaInuIcon_svg__st2' d='M1377.6 343.2c-.2.2-.3.5-.5.7' />
      <path
        id='ShibaInuIcon_svg__Path_8584'
        className='ShibaInuIcon_svg__st2'
        d='M1509.1 476.9c-.5 1.4-.7 2.1-.7 2.1'
      />
      <g id='ShibaInuIcon_svg__Group_934'>
        <g id='ShibaInuIcon_svg__Group_933'>
          <g id='ShibaInuIcon_svg__Group_932'>
            <path
              id='ShibaInuIcon_svg__Path_8585'
              className='ShibaInuIcon_svg__st4'
              d='M1518.1 296.1c-7.8-1-44.7-1.2-86.5 77.1l-.2-.1c-16.8-13.4-29.4-19.7-29.4-19.7 66.1-76 107-80.2 107-80.2 4.6 6.1 7.5 13.9 9.1 22.9z'
            />
          </g>
          <path
            id='ShibaInuIcon_svg__Path_8586'
            className='ShibaInuIcon_svg__st5'
            d='M1491.3 443.1c-15.2-27-35.4-50.7-59.7-69.9 41.8-78.3 78.6-78.1 86.5-77.1 9.3 53.5-26.8 147-26.8 147z'
          />
          <path id='ShibaInuIcon_svg__Path_8587' className='ShibaInuIcon_svg__st5' d='m1519.6 296.4-1.5-.3 1.5.3z' />
        </g>
      </g>
      <path
        id='ShibaInuIcon_svg__Path_8588'
        className='ShibaInuIcon_svg__st2'
        d='M1175.1 347.1c-1-1.4-2.1-2.8-3.1-4.2'
      />
      <path
        id='ShibaInuIcon_svg__Path_8589'
        className='ShibaInuIcon_svg__st2'
        d='M1035 480.8c1.1 3.4 1.8 5.2 1.8 5.2'
      />
      <g id='ShibaInuIcon_svg__Group_937'>
        <g id='ShibaInuIcon_svg__Group_936'>
          <g id='ShibaInuIcon_svg__Group_935'>
            <path
              id='ShibaInuIcon_svg__Path_8590'
              className='ShibaInuIcon_svg__st4'
              d='M1146.2 353.4s-13 6.3-30.4 19.7c0 0-.1.1-.2.1-43.3-78.4-81.4-78.1-89.6-77.1 1.6-9 4.6-16.9 9.3-22.9.1 0 42.5 4.2 110.9 80.2z'
            />
          </g>
          <path
            id='ShibaInuIcon_svg__Path_8591'
            className='ShibaInuIcon_svg__st5'
            d='M1115.7 373.2c-19 14.6-43.2 37.5-61.8 69.9 0 0-37.4-93.5-27.8-147 8.1-1 46.3-1.2 89.6 77.1z'
          />
          <path
            id='ShibaInuIcon_svg__Path_8592'
            className='ShibaInuIcon_svg__st5'
            d='M1026.1 296.1c-.5.1-1.1.2-1.6.3l1.6-.3z'
          />
        </g>
      </g>
      <path
        id='ShibaInuIcon_svg__Path_8593'
        className='ShibaInuIcon_svg__st1'
        d='M1390.1 495s-32 2-28-23 29-28 36-27 35 11 30 32-12 17-16 18-22 0-22 0z'
      />
      <path
        id='ShibaInuIcon_svg__Path_8594'
        className='ShibaInuIcon_svg__st1'
        d='M1154.1 495s-32 2-28-23 29-28 36-27 35 11 30 32-12 17-16 18-22 0-22 0z'
      />
    </g>
  </svg>
)

export default SvgShibaInuIcon
